"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var LanguageGlobe = function LanguageGlobe(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    stroke: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M13.8333 7.16667C13.8333 10.8486 10.8486 13.8333 7.16667 13.8333M13.8333 7.16667C13.8333 3.48477 10.8486 0.5 7.16667 0.5M13.8333 7.16667H0.5M7.16667 13.8333C3.48477 13.8333 0.5 10.8486 0.5 7.16667M7.16667 13.8333C5.45482 12.0359 4.5 9.64884 4.5 7.16667C4.5 4.68449 5.45482 2.29744 7.16667 0.5M7.16667 13.8333C8.87851 12.0359 9.83333 9.64884 9.83333 7.16667C9.83333 4.68449 8.87851 2.29744 7.16667 0.5M0.5 7.16667C0.5 3.48477 3.48477 0.5 7.16667 0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var _default = LanguageGlobe;
exports.default = _default;